import { createFeatureSelector, createSelector } from '@ngrx/store';
import { CounterpartiesState } from './state';

export const CounterpartiesFeature = 'CounterpartiesFeature';

export const counterpartiesFeatureStateSelector =
  createFeatureSelector<CounterpartiesState>(CounterpartiesFeature);

export const selectCounterparties = createSelector(
  counterpartiesFeatureStateSelector,
  (state: CounterpartiesState) => state.counterparties,
);

export const selectCounterpartiesLoading = createSelector(
  counterpartiesFeatureStateSelector,
  (state: CounterpartiesState) => state.loadingCounterparties,
);

export const selectCounterpartyCreating = createSelector(
  counterpartiesFeatureStateSelector,
  (state: CounterpartiesState) => state.loadingCounterparty,
);

export const selectCloseCreatingCounterpartyModal = createSelector(
  counterpartiesFeatureStateSelector,
  (state: CounterpartiesState) => state.closeCreatingCounterpartyModal,
);

export const selectCounterpartyLoading = createSelector(
  counterpartiesFeatureStateSelector,
  (state: CounterpartiesState) => state.loadingCounterparty,
);

export const selectCounterparty = createSelector(
  counterpartiesFeatureStateSelector,
  (state: CounterpartiesState) => state.counterparty,
);

export const selectCounterpartyEditing = createSelector(
  counterpartiesFeatureStateSelector,
  (state: CounterpartiesState) => state.editingCounterparty,
);

export const selectCloseEditingCounterpartyModal = createSelector(
  counterpartiesFeatureStateSelector,
  (state: CounterpartiesState) => state.closeEditingCounterpartyModal,
);

export const fromCounterparties = {
  selectCounterparties,
  selectCounterpartiesLoading,
  selectCloseCreatingCounterpartyModal,
  selectCounterpartyCreating,
  selectCounterparty,
  selectCounterpartyLoading,
  selectCounterpartyEditing,
  selectCloseEditingCounterpartyModal,
};
